import { render, staticRenderFns } from "./RequestInfoSection.vue?vue&type=template&id=97b90db4&scoped=true&"
import script from "./RequestInfoSection.vue?vue&type=script&lang=js&"
export * from "./RequestInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./RequestInfoSection.vue?vue&type=style&index=0&id=97b90db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b90db4",
  null
  
)

export default component.exports